import React, { Component } from "react";
import RolePermissionManagementService from '@services/RolePermissionManagementService';
import SpinnerModal from "@components/SpinnerModal";
import { useDialog } from 'react-st-modal';
import styles from './edituserrolepermissiondialog.module.css';
import SupportAlert from '@components/SupportAlert';
import Alert from '@mui/material/Alert';
import { FormControl, FormControlLabel, Grid, Table, TableHead, TableBody, TableCell, TableContainer, TableRow, Tooltip, Paper, Checkbox, Switch } from '@mui/material';

class EditUserRolePermissionDialog extends Component {
    state = {
        loading: false,
        isNotAdministratorRole: true,
        updateOwnRoles: false,
        isOwnRole: false,
        updateOwnPermissions: false,
        currentUserId: null,
        userRoles: [],
        systemRoles: [],
        systemRolePermissions: [],
        systemPermissions: [],
        userPermissions: [],
    }

    parseJwt(token) {
        const base64Payload = token.split('.')[1];
        const payload = atob(base64Payload);
        return JSON.parse(payload.toString());
    }

    async componentDidMount() {
        this.setState({ loading: true });

        let payload = this.parseJwt(localStorage.getItem('Bearer'));

        this.setState({ currentUserId: payload.user_id });

        this.reloadCurrentUserRoles(payload.user_id);

        this.reloadUserRoles(this.props.realmUser.attributes.user_id);

        this.reloadUserPermissions(this.props.realmUser.attributes.user_id);

        this.reloadSystemRoles();

        this.reloadSystemPermissions();

        this.reloadRolePermissions();

        const updateOwnRoles = await RolePermissionManagementService.userRolesCanActionResource(
            ['ADMINISTRATOR'],
            'UPDATE',
            'OWN_ROLES'
        );
        this.setState({ updateOwnRoles: updateOwnRoles });

        const updateOwnPermissions = await RolePermissionManagementService.userRolesCanActionResource(
            ['ADMINISTRATOR'],
            'UPDATE',
            'OWN_PERMISSIONS'
        );
        this.setState({ updateOwnPermissions: updateOwnPermissions });

        const isOwnRole = (parseFloat(this.props.realmUser.attributes.user_id) === parseFloat(payload.user_id));
        this.setState({ isOwnRole: isOwnRole });

        this.setState({ loading: false });
    }

    async reloadRolePermissions() {
        this.setState({ loading: true });

        await (async () => {
            try {
                const systemRolePermissions = await RolePermissionManagementService.getRdiSystemRolePermissionsAll();
                this.setState({ systemRolePermissions: JSON.parse(JSON.stringify(systemRolePermissions)) });
                return systemRolePermissions;
            } catch (ex) {
                console.log('Network error loading system role-permissions');
            }
        })([]);

        this.setState({ loading: false });
    }

    async reloadCurrentUserRoles(surveysUserId) {
        await (async () => {
            try {
                const userRoles = await RolePermissionManagementService.getRdiUserRoles(surveysUserId);
                const isNotAdministratorRole = !userRoles.some(userRole => (userRole.role.name === 'ADMINISTRATOR'));
                this.setState({ isNotAdministratorRole: isNotAdministratorRole });
            } catch (ex) {
                console.log('Network error loading current user roles');
            }
        })([]);
    }

    async reloadUserRoles(surveysUserId) {
        await (async () => {
            try {
                const userRoles = await RolePermissionManagementService.getRdiUserRoles(surveysUserId);
                this.setState({ userRoles: JSON.parse(JSON.stringify(userRoles)) });
                return userRoles;
            } catch (ex) {
                console.log('Network error loading user roles');
            }
        })([]);
    }

    async reloadUserPermissions(surveysUserId) {
        await (async () => {
            try {
                const userPermissions = await RolePermissionManagementService.getRdiUserPermissions(surveysUserId);
                this.setState({ userPermissions: JSON.parse(JSON.stringify(userPermissions)) });
                return userPermissions;
            } catch (ex) {
                console.log('Network error loading user permissions');
            }
        })([]);
    }

    async reloadSystemRoles() {
        this.setState({ loading: true });

        await (async () => {
            try {
                const systemRolesAll = await RolePermissionManagementService.getRdiSystemRoles();
                this.setState({ systemRoles: JSON.parse(JSON.stringify(systemRolesAll)) });
                return systemRolesAll;
            } catch (ex) {
                console.log('Network error loading system roles');
            }
        })([]);

        this.setState({ loading: false });
    }

    async reloadSystemPermissions() {
        this.setState({ loading: true });

        await (async () => {
            try {
                const systemPermissions = await RolePermissionManagementService.getRdiSystemPermissions();
                this.setState({ systemPermissions: JSON.parse(JSON.stringify(systemPermissions)) });
                return systemPermissions;
            } catch (ex) {
                console.log('Network error loading system permissions');
            }
        })([]);

        this.setState({ loading: false });
    }

    handleAddRemoveUserRolesCheckboxClick = (event, systemRole) => {

        if (!this.state.userRoles.some(userRole => userRole.id.roleId === systemRole.id)) {
            (async () => {
                try {
                    const newUserRoleEnvelope = [{
                        actionById: this.state.currentUserId,
                        userId: this.props.realmUser.attributes.user_id[0],
                        roleId: systemRole.id
                    }]
                    await RolePermissionManagementService.saveUserRoles(newUserRoleEnvelope);
                    await this.reloadUserRoles(this.props.realmUser.attributes.user_id[0]);
                } catch (ex) {
                    console.log('Error adding user-role: ' + ex);
                }
            })([]);
        } else {
            (async () => {
                try {
                    await RolePermissionManagementService.removeRoleFromUser(this.props.realmUser.attributes.user_id[0], systemRole.id, this.state.currentUserId);
                    await this.reloadUserRoles(this.props.realmUser.attributes.user_id[0]);
                } catch (ex) {
                    console.log('Error removing user-roles ' + ex);
                }
            })([]);
        }
    }

    handleAddRemoveUserPermissionCheckboxClick = (event, systemPermission) => {

        if (!this.state.userPermissions.some(userPermission => userPermission.id.permissionId === systemPermission.id)) {
            (async () => {
                try {
                    const newUserPermissionEnvelope = [{
                        actionById: this.state.currentUserId,
                        userId: this.props.realmUser.attributes.user_id[0],
                        permissionId: systemPermission.id,
                        grantType: 'ALLOW'
                    }]
                    await RolePermissionManagementService.saveUserPermissions(newUserPermissionEnvelope);
                    await this.reloadUserPermissions(this.props.realmUser.attributes.user_id[0]);
                } catch (ex) {
                    console.log('Error updating user-permission: ' + ex);
                }
            })([]);
        } else {
            const count = this.state.userPermissions.filter(userPermission => userPermission.id.permissionId === systemPermission.id).length;
            if (count > 1) {
                SupportAlert.displayAlert('Remove permission from user.', 'This permission is also granted through other roles. Please contact your system administrator.');
            } else {
                (async () => {
                    try {
                        await RolePermissionManagementService.removePermissionFromUser(this.props.realmUser.attributes.user_id[0], systemPermission.id, this.state.currentUserId);
                        await this.reloadUserPermissions(this.props.realmUser.attributes.user_id[0]);
                    } catch (ex) {
                        console.log('Error updating user-permission: ' + ex);
                    }
                })([]);
            }
        }
    }

    async handleFlipUserPermissionGrantType(evt, permissionId) {
        if (this.state.userPermissions.some(userPermission => userPermission.id.permissionId === permissionId)) {
            const updateUserPermission = this.state.userPermissions.find(userPermission => userPermission.id.permissionId === permissionId);
            updateUserPermission.grantType = (updateUserPermission.grantType === 'ALLOW' ? 'DENY' : 'ALLOW');

            (async () => {
                try {
                    const userPermissionEnvelope = [{
                        actionById: this.state.currentUserId,
                        userId: updateUserPermission.id.surveysUserId,
                        permissionId: updateUserPermission.id.permissionId,
                        grantType: updateUserPermission.grantType
                    }]
                    await RolePermissionManagementService.saveUserPermissions(userPermissionEnvelope);
                    this.setState({ userPermissions: [...this.state.userPermissions.filter(userPermission => userPermission.id.permissionId !== permissionId), updateUserPermission] });
                } catch (ex) {
                    console.log('Error updating user-permission: ' + ex);
                }
            })([]);
        }
    }

    dialogBody() {

        return <div className={styles.flex_row_container}>
            <div className={styles.featuredItem}>
                <Alert variant="outlined" severity="warning">{'You are about to update ' + this.props.action.toLowerCase() + ' for the researcher user [ ' + this.props.realmUser.email + ' ]. Please note that all changes are applied immediately.'}</Alert>
            </div>
            {this.props.action === 'Roles'
                ? <div className={styles.featuredItem}>
                    <h1>
                        <text className={styles.featuredTitleHeader}>{"User Roles: " + this.props.realmUser.firstName + " " + this.props.realmUser.lastName + ' [ ' + this.props.realmUser.email + ' ]'}</text>
                    </h1>
                    <br />
                    <p>
                        <Grid container spacing={3} direction="row" justify-content="space-between" wrap="nowrap">
                            {(this.state.systemRoles !== undefined && this.state.systemRoles !== null && this.state.systemRoles.length > 0)
                                ? <div className={styles.featuredTable}>
                                    <TableContainer component={Paper} elevation={0}>
                                        <Table size="small">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell className={styles.table_header_cell}>
                                                        <text className={styles.featuredTitleHeader}>{'ADDED'}</text>
                                                    </TableCell>
                                                    <TableCell className={styles.table_header_cell}>
                                                        <text className={styles.featuredTitleHeader}>{
                                                            'ROLE NAME'
                                                        }</text>
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {this.state.systemRoles.sort((a, b) => a.id >= b.id ? 1 : -1).map(systemRole => {
                                                    return (
                                                        <Tooltip
                                                            key={systemRole.name}
                                                            title={systemRole.description}
                                                            followCursor
                                                            placement="top-start"
                                                            componentsProps={{
                                                                tooltip: {
                                                                    sx: {
                                                                        bgcolor: '#0078D4',
                                                                        color: 'white',
                                                                        fontSize: '12px',
                                                                        padding: '10px',
                                                                        borderRadius: '5px',
                                                                        maxWidth: '100%',
                                                                        '& .MuiTooltip-arrow': {
                                                                            color: '#0078D4'
                                                                        }
                                                                    }
                                                                }
                                                            }}
                                                        >
                                                            <TableRow
                                                                key={systemRole.name}
                                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                            >
                                                                <TableCell component="td">
                                                                    {(systemRole.name.toUpperCase() === 'ADMINISTRATOR')
                                                                        ? <Checkbox
                                                                            disabled={((this.state.isNotAdministratorRole) || (!this.state.updateOwnRoles && this.state.isOwnRole))}
                                                                            checked={this.state.userRoles.some(userRole => userRole.id.roleId === systemRole.id)}
                                                                            size="small"
                                                                            onChange={(event) => this.handleAddRemoveUserRolesCheckboxClick(event, systemRole)}
                                                                            color="primary"
                                                                            sx={{
                                                                                '&.MuiCheckbox-root': {
                                                                                    padding: '4px',
                                                                                },
                                                                                '& .MuiSvgIcon-root': {
                                                                                    width: '20px',
                                                                                    height: '20px'
                                                                                }
                                                                            }}
                                                                        />
                                                                        : <Checkbox
                                                                            disabled={(!this.state.updateOwnRoles && this.state.isOwnRole)}
                                                                            checked={this.state.userRoles.some(userRole => userRole.id.roleId === systemRole.id)}
                                                                            size="small"
                                                                            onChange={(event) => this.handleAddRemoveUserRolesCheckboxClick(event, systemRole)}
                                                                            color="primary"
                                                                            sx={{
                                                                                '&.MuiCheckbox-root': {
                                                                                    padding: '4px',
                                                                                },
                                                                                '& .MuiSvgIcon-root': {
                                                                                    width: '20px',
                                                                                    height: '20px'
                                                                                }
                                                                            }}
                                                                        />
                                                                    }
                                                                </TableCell>
                                                                <TableCell component="td">
                                                                    <text className={styles.featuredText}>
                                                                        {systemRole.name.toUpperCase()}
                                                                    </text>
                                                                </TableCell>

                                                            </TableRow>
                                                        </Tooltip>
                                                    )
                                                })}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </div>
                                : null
                            }
                        </Grid>
                    </p>
                </div>
                : <div className={styles.featuredItem}>
                    <h1>
                        <text className={styles.featuredTitleHeader}>{"User Permissions: " + this.props.realmUser.firstName + " " + this.props.realmUser.lastName + ' [ ' + this.props.realmUser.email + ' ]'}</text>
                    </h1>
                    <br />
                    <p>
                        <Grid container spacing={3} direction="row" justify-content="space-between" wrap="nowrap">
                            {(this.state.systemRoles !== undefined && this.state.systemRoles !== null && this.state.systemRoles.length > 0)
                                ? <div className={styles.featuredTable}>
                                    <TableContainer component={Paper} elevation={0}>
                                        <Table size="small">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell className={styles.table_header_cell}>
                                                        <text className={styles.featuredTitleHeader}>{'Added'.toUpperCase()}</text>
                                                    </TableCell>
                                                    <TableCell className={styles.table_header_cell}>
                                                        <text className={styles.featuredTitleHeader}>{
                                                            'Permission Name'.toUpperCase()
                                                        }</text>
                                                    </TableCell>
                                                    <TableCell className={styles.table_header_cell}>
                                                        <text className={styles.featuredTitleHeader}>{
                                                            'Grant Type'.toUpperCase()
                                                        }</text>
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {this.state.systemPermissions.sort((a, b) => a.id > b.id ? 1 : -1).map(systemPermission => {
                                                    return (
                                                        <Tooltip
                                                            key={systemPermission.name}
                                                            title={systemPermission.description}
                                                            followCursor
                                                            placement="top-start"
                                                            componentsProps={{
                                                                tooltip: {
                                                                    sx: {
                                                                        bgcolor: '#0078D4',
                                                                        color: 'white',
                                                                        fontSize: '12px',
                                                                        padding: '10px',
                                                                        borderRadius: '5px',
                                                                        maxWidth: '100%',
                                                                        '& .MuiTooltip-arrow': {
                                                                            color: '#0078D4'
                                                                        }
                                                                    }
                                                                }
                                                            }}
                                                        >
                                                            <TableRow
                                                                key={systemPermission.name}
                                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                            >
                                                                <TableCell component="td">
                                                                    <Checkbox
                                                                        disabled={(!this.state.updateOwnPermissions && this.state.isOwnRole)}
                                                                        checked={this.state.userPermissions.some(userPermission => userPermission.permission.id === systemPermission.id)}
                                                                        size="small"
                                                                        onChange={(event) => this.handleAddRemoveUserPermissionCheckboxClick(event, systemPermission)}
                                                                        color="primary"
                                                                        sx={{
                                                                            '&.MuiCheckbox-root': {
                                                                                padding: '4px',
                                                                            },
                                                                            '& .MuiSvgIcon-root': {
                                                                                width: '20px',
                                                                                height: '20px'
                                                                            }
                                                                        }}
                                                                    />
                                                                </TableCell>
                                                                <TableCell component="td">
                                                                    <text className={styles.featuredText}>
                                                                        {systemPermission.name.toUpperCase()}
                                                                    </text>
                                                                </TableCell>
                                                                <TableCell component="td">
                                                                    <FormControl>
                                                                        <FormControlLabel
                                                                            control={
                                                                                <Switch
                                                                                    disabled={((!this.state.updateOwnPermissions && this.state.isOwnRole) || !(this.state.userPermissions.some(userPermission => userPermission.permission.id === systemPermission.id)))}
                                                                                    name='allow_role_permission'
                                                                                    size='small'
                                                                                    color='primary'
                                                                                    checked={(this.state.userPermissions.filter(userPermission => (userPermission.id.permissionId === systemPermission?.id))[0]?.grantType?.toUpperCase() === 'ALLOW')}
                                                                                    onChange={(evt) => {
                                                                                        this.handleFlipUserPermissionGrantType(evt, systemPermission.id)
                                                                                    }}
                                                                                />
                                                                            }
                                                                            label={(this.state.userPermissions.filter(userPermission => userPermission.id.permissionId === systemPermission?.id)[0]?.grantType?.toUpperCase() === 'ALLOW') ? "ALLOW" : "DENY"}
                                                                        />
                                                                    </FormControl>
                                                                </TableCell>
                                                            </TableRow>
                                                        </Tooltip>
                                                    )
                                                })}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </div>
                                : null
                            }
                        </Grid>
                    </p>
                </div>
            }
        </div>
    }

    render() {
        if (this.state.loading === true) {
            return <SpinnerModal settings={true} label={'Dialog loading ...'} />
        } else {
            return <DialogWrapper
                {...this.props}
                content={
                    <React.Fragment>
                        {this.dialogBody()}
                    </React.Fragment>
                }
            />
        }
    }

}
export default EditUserRolePermissionDialog;

function DialogWrapper(props) {
    const dialog = useDialog();

    return (
        <div>
            <br />
            <div>
                {props.content}
            </div>
            <div>
                {props.backButton !== undefined && props.backButton !== null
                    ? <button type="button" className="btnBack"
                        onClick={() => {
                            dialog.close(false);
                        }}
                    >
                        {props.backButton.text}
                    </button>
                    : <div />
                }
                {props.nextButton !== undefined && props.nextButton !== null
                    ? <button type="button" className="btnNext"
                        onClick={(evt) => {
                            props.onClick(evt);
                            dialog.close(true);
                        }}
                    >
                        {props.nextButton.text}
                    </button>
                    : <div />
                }
            </div>
        </div>
    );
}

